<template>
    <v-dialog
        class="bind-wechat-dialog"
        :open="name === 'bindWechatDialog'"
        :title="showTitle ? '绑定微信' : ''"
        @close="$emit('update:name', '')"
    >
        <div
            v-if="showTitle"
            slot="subtitle"
        >
            绑定后可用微信扫码快捷登录企点
        </div>
        <div class="body">
            <div
                v-if="step === 1"
                class="qrcode"
            >
                <qd-login-wx
                    render-id="WxLoginBind"
                    :show-tips="false"
                    :custom-message-handle="true"
                    :redirect-url="WECHAT.FIRST_BIND_WECHAT"
                    @message="handleMessageHandler"
                />
            </div>
            <div
                v-else-if="step === 2"
                class="step2"
            >
                <div class="tip-icon" />
                <div class="tip-text">
                    <p>微信号{{ wechat }}已绑定账号</p>
                    <p>{{ account }}</p>
                </div>
                <div class="tip-description">
                    <p>
                        是否将该微信号绑定至当前账号 <span class="blue">{{ aid }}</span>？
                    </p>
                    <p>
                        替换绑定后，原绑定账号<span class="blue">{{ account }}</span>将与该微信号解绑
                    </p>
                </div>
                <div class="btn-row">
                    <v-button
                        status="primary"
                        style="margin-right:20px;"
                        :loading="bindLoading"
                        size="large"
                        @click="handleBindCurrentCount"
                    >
                        绑定至当前账号
                    </v-button>
                    <v-button
                        status="default"
                        size="large"
                        @click="step = 1"
                    >
                        重新扫码
                    </v-button>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import Gateway from '@/utils/Gateway';
import QdLoginWx from '../wechat.js';
import WECHAT from './const';

const CHANGE_WX_URL = '/v1/basic.account.account_web.AccountWeb/ForceAddAccount'; // 替换微信
export default {
    components: {
        QdLoginWx,
    },
    props: {
        isChangeWechat: {
            type: Boolean,
            default: false,
        },
        aid: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: 'validateWechat',
        },
    },
    data() {
        return {
            WECHAT,
            wechat: '',
            account: '',
            step: 1,
            bindLoading: false,
        };
    },
    computed: {
        showTitle() {
            return this.step === 1;
        },
    },
    methods: {
        handleMessageHandler(res) {
            console.log(res);
            const { data } = res.data;
            const code = parseInt(data.code, 10);
            if (code === 0) {
                this.$message.success('微信验证成功');
                this.$emit('update:name', '');
                this.$emit('on-success');
            } else if (code === 300010) {
                this.step = 2;
                this.openid = data.data.openid;
                this.account = data.data.aid;
            } else {
                this.$message.error(data.message);
            }
        },
        handleBindCurrentCount() {
            const params = {
                openid: this.openid,
            };
            Gateway.post(CHANGE_WX_URL, params)
                .then(() => {
                    this.$emit('update:name', '');
                    this.$emit('on-success');
                })
                .catch((err) => {
                    this.$message.error(err || '网络故障，请稍后再试');
                });
        },
    },
};
</script>

<style lang="less">
.bind-wechat-dialog {
    .v-dialog__content {
        width: 400px;
        padding: 40px 0 60px;
        .v-dialog__body {
            margin-top: 35px;
        }
    }
    .body {
        .qrcode {
            // max-width: 200px;
            // max-height: 200px;
            display: block;
            margin: 0 auto;
        }
        .step2 {
            margin-top: -70px;
            margin-bottom: -15px;
            padding: 0 20px;
            .tip-icon {
                width: 40px;
                height: 40px;
                background: url('../../assets/ic_warning@2x.png') no-repeat;
                background-size: cover;
                margin: 0 auto;
            }
            .tip-text {
                margin-top: 20px;
                font-size: 24px;
                line-height: 33px;
                color: #1e2330;
                text-align: center;
                word-break: break-all;
            }
            .tip-description {
                margin-top: 20px;
                color: #a8abb3;
                line-height: 20px;
            }

            .blue {
                font-size: 14px;
                color: #0067ed;
            }

            .btn-row {
                margin-top: 50px;
            }
        }
    }
}
</style>
